import ModelPlayer from './ModelPlayer'
export default ModelPlayer
